export default __webpack_public_path__ + "static/media/human.766a9ef0.svg";